export default __webpack_public_path__ + "static/media/ic-remove.93e406ec.svg";